import { FunctionComponent } from 'react';
import { CheckMark } from '@/components/common/icons/CheckMark';
import { Close } from '@/components/common/icons/Close';
import './ToggleSwitch.scss';

interface ToggleSwitchProps {
  value: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}

export const ToggleSwitch: FunctionComponent<ToggleSwitchProps> = ({
  value,
  disabled = false,
  onChange,
}) => (
  <span className="toggle-switch">
    <input
      className="sr-only"
      type="checkbox"
      checked={value}
      disabled={disabled}
      onChange={(e) => onChange(e.target.checked)}
    />
    <span className="toggle-switch__toggle">
      <CheckMark width="1.25em" height="1.25em" className="toggle-switch__checked" />
      <Close width=".625em" height=".625em" className="toggle-switch__unchecked" />
    </span>
  </span>
);
